var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { eventRegistry } from '../../../registry/Registry';
import { uniq } from '../../../utils/helper/lodash_replacements';
export class AppEvents {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        if (typeof window !== 'undefined') {
            window.addEventListener('build', this.fireGlobalEvent, false);
        }
    }
    get app() {
        return this.parent;
    }
    fireGlobalEvent(rawEvent) {
        const handlerName = eventRegistry.registry_object[rawEvent.type].handlerName;
        console.log('fireGlobalEvent', handlerName);
        const listeningAspects = uniq(this.app.importingTree.importingSearch
            .allActiveTraitsOfKey(handlerName)
            .filter(rawEvent.customFilter || (at => true))
            .map(at => at.aspect));
        return this.fireEventToAspects(rawEvent, listeningAspects);
    }
    fireEventToAspects(rawEvent, aspects) {
        const handlerName = eventRegistry.registry_object[rawEvent.type].handlerName;
        // if (aspects.length === 0) return;
        const event = this.app.core.aspectEvents.eventCreation.createFromRawEvent(rawEvent);
        aspects.forEach(aspect => aspect.aspectEvents.eventReception.handleEvent(event));
        return event;
    }
}
__decorate([
    action.bound
], AppEvents.prototype, "fireGlobalEvent", null);
__decorate([
    action.bound
], AppEvents.prototype, "fireEventToAspects", null);
